import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../../components/feature/Navbar";
import FooterSection from "../home/components/FooterSection";

const PLANS = [
  {
    id: "basic",
    name: "AI 인턴 채용하기",
    price: "20,000",
    unit: "원 / 월·인",
    badge: null,
    desc: "기초 프롬프트 & AI 피드백으로 칼퇴 루틴을 처음 만드는 세오님께 딱 맞아요.",
    color: "#191F28",
    btnStyle: "border-2 border-[#191F28] text-[#191F28] hover:bg-[#191F28] hover:text-white",
    features: [
      "월 12개 수익화 AI 챌린지",
      "세오님 전용 대시보드",
      "AI 1차 자동 피드백",
      "주간 성과 리포트",
      "이메일 고객 지원",
    ],
    limit: "~ 50명",
  },
  {
    id: "standard",
    name: "AI 실무자 채용하기",
    price: "25,000",
    unit: "원 / 월·인",
    badge: "가장 인기",
    desc: "수익화 템플릿 + 파티 플레이로 N잡 파이프라인을 본격 구축하는 플랜이에요.",
    color: "#00D873",
    btnStyle: "bg-[#00D873] text-white hover:opacity-90",
    features: [
      "월 24개 수익형 AI 챌린지",
      "3-2-1 대시보드 전체 기능",
      "AI + 전문가 크로스 피드백",
      "파티 챌린지 (팀 수익화) 기능",
      "Grow Points 리워드 시스템",
      "일간/주간 수익 성과 리포트",
      "전용 카카오채널 지원",
    ],
    limit: "~ 200명",
  },
  {
    id: "premium",
    name: "AI 임원급 채용하기",
    price: "30,000",
    unit: "원 / 월·인",
    badge: null,
    desc: "무제한 챌린지 + 커스텀 프롬프트 제작으로 팀 전체를 세오로 만드는 풀 패키지.",
    color: "#191F28",
    btnStyle: "border-2 border-[#191F28] text-[#191F28] hover:bg-[#191F28] hover:text-white",
    features: [
      "무제한 수익화 AI 챌린지",
      "관리자 전용 LMS 대시보드",
      "AI + 전문가 + 동료 피드백 시스템",
      "커스텀 챌린지 직접 제작",
      "API 연동 지원",
      "월간 수익 성과 분석 리포트",
      "전담 CS 매니저 배정",
    ],
    limit: "~ 1,000명",
  },
  {
    id: "custom",
    name: "우리 회사 전 직원 세오 만들기",
    price: "맞춤",
    unit: "견적 문의",
    badge: "기업·기관 맞춤",
    desc: "학교·정부기관·대기업의 전 직원을 세오님으로 만드는 완전 맞춤형 솔루션이에요.",
    color: "#191F28",
    btnStyle: "bg-[#191F28] text-white hover:opacity-80",
    features: [
      "전체 기능 무제한 포함",
      "온프레미스 / 클라우드 구축 선택",
      "브랜드 화이트라벨 지원",
      "전문 강사 파견 연계",
      "24/7 기술 지원 SLA 계약",
      "정부 조달 등록 지원",
    ],
    limit: "인원 제한 없음",
  },
];

const FAQS = [
  { q: "무료 체험 기간이 있나요?", a: "네! 모든 플랜에 14일 무료 체험 기간이 제공됩니다. 신용카드 없이 바로 시작하실 수 있어요." },
  { q: "중간에 플랜 변경이 가능한가요?", a: "네, 언제든지 업그레이드 또는 다운그레이드가 가능합니다. 변경 시점부터 새 요금이 적용됩니다." },
  { q: "학생 수가 중간에 변경되면 어떻게 되나요?", a: "월별 실제 활성 사용자 기준으로 정산됩니다. 예상 인원보다 적게 사용해도 최소 단위 인원 이상이면 차감 됩니다." },
  { q: "정부 조달 등록 제품인가요?", a: "현재 조달청 등록 절차를 진행 중이며, Custom 플랜의 경우 별도 협의를 통해 구매 절차를 지원해 드립니다." },
];

function ContactModal({ plan, onClose }: { plan: string; onClose: () => void }) {
  const [form, setForm] = useState({ name: "", email: "", org: "", message: "" });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.org) return;
    setLoading(true);
    try {
      const body = new URLSearchParams();
      body.append("email", form.email);
      body.append("name", form.name);
      body.append("org", form.org);
      body.append("plan", plan);
      body.append("message", form.message);
      const res = await fetch("https://readdy.ai/api/form/d7552qcprit363gl0v4g", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      if (res.ok) setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center px-4 py-8 overflow-y-auto">
      <div className="bg-white rounded-3xl w-full max-w-md p-8 relative">
        <button onClick={onClose} className="absolute top-5 right-5 w-8 h-8 flex items-center justify-center text-[#191F28]/30 hover:text-[#191F28] cursor-pointer">
          <i className="ri-close-line text-xl" />
        </button>
        {!submitted ? (
          <>
            <div className="mb-7">
              <h3 className="text-2xl font-black text-[#191F28]">도입 문의하기</h3>
              <p className="text-sm text-[#191F28]/50 mt-1"><strong className="text-[#00D873]">{plan}</strong> 플랜에 관심을 가져주셔서 감사해요 🙌</p>
            </div>
            <form data-readdy-form id="pricing-contact-form" onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="text-xs font-semibold text-[#191F28]/60 block mb-1.5">담당자 성함 *</label>
                <input
                  type="text"
                  name="name"
                  required
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  placeholder="홍길동"
                  className="w-full bg-[#F2F4F6] rounded-xl px-4 py-3 text-sm text-[#191F28] outline-none focus:ring-2 focus:ring-[#00D873]"
                />
              </div>
              <div>
                <label className="text-xs font-semibold text-[#191F28]/60 block mb-1.5">이메일 *</label>
                <input
                  type="email"
                  name="email"
                  required
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  placeholder="example@school.ac.kr"
                  className="w-full bg-[#F2F4F6] rounded-xl px-4 py-3 text-sm text-[#191F28] outline-none focus:ring-2 focus:ring-[#00D873]"
                />
              </div>
              <div>
                <label className="text-xs font-semibold text-[#191F28]/60 block mb-1.5">기관명 *</label>
                <input
                  type="text"
                  name="org"
                  required
                  value={form.org}
                  onChange={(e) => setForm({ ...form, org: e.target.value })}
                  placeholder="OO대학교 / OO기관"
                  className="w-full bg-[#F2F4F6] rounded-xl px-4 py-3 text-sm text-[#191F28] outline-none focus:ring-2 focus:ring-[#00D873]"
                />
              </div>
              <div>
                <label className="text-xs font-semibold text-[#191F28]/60 block mb-1.5">문의 내용</label>
                <textarea
                  name="message"
                  value={form.message}
                  onChange={(e) => { if (e.target.value.length <= 500) setForm({ ...form, message: e.target.value }); }}
                  placeholder="예상 수강 인원, 도입 시기, 특이 사항 등을 적어주세요."
                  className="w-full bg-[#F2F4F6] rounded-xl px-4 py-3 text-sm text-[#191F28] outline-none focus:ring-2 focus:ring-[#00D873] resize-none h-24"
                />
                <div className="text-xs text-[#191F28]/30 text-right">{form.message.length}/500</div>
              </div>
              <button
                type="submit"
                disabled={loading || !form.name || !form.email || !form.org}
                className="w-full bg-[#00D873] text-white font-black py-4 rounded-2xl cursor-pointer hover:opacity-90 transition-opacity disabled:opacity-40 whitespace-nowrap"
              >
                {loading ? "전송 중..." : "문의 보내기 →"}
              </button>
            </form>
          </>
        ) : (
          <div className="text-center py-8">
            <div className="text-5xl mb-4">🎉</div>
            <h3 className="text-2xl font-black text-[#191F28] mb-2">문의 완료!</h3>
            <p className="text-[#191F28]/60 text-sm leading-relaxed">
              영업일 기준 1~2일 내에 담당자가<br />연락드릴 예정이에요.
            </p>
            <button onClick={onClose} className="mt-8 bg-[#F2F4F6] text-[#191F28] font-bold px-8 py-3 rounded-full cursor-pointer whitespace-nowrap">
              닫기
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default function PricingPage() {
  const [selectedPlan, setSelectedPlan] = useState<string | null>(null);
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [billing, setBilling] = useState<"monthly" | "annual">("annual");

  return (
    <div className="min-h-screen bg-white font-sans">
      <Navbar />
      <div className="pt-24">

        {/* ── Hero ── */}
        <section className="py-20 lg:py-28 px-6 text-center bg-white">
          <div className="max-w-3xl mx-auto">
            <span className="inline-flex items-center gap-2 bg-[#00D873]/10 text-[#00D873] text-sm font-bold px-4 py-2 rounded-full mb-8">
              <span className="w-1.5 h-1.5 bg-[#00D873] rounded-full animate-pulse" />
              세오님을 위한 AI 성장 플랜
            </span>
            <h1 className="text-4xl lg:text-6xl font-black text-[#191F28] leading-tight mb-6">
              세오님의 시간을<br />
              <span className="text-[#00D873]">가장 싸게 사는 방법</span>
            </h1>
            <p className="text-lg text-[#191F28]/60 mb-10 leading-relaxed">
              AI 인턴 한 명 채용하는 가격으로, 칼퇴 + N잡 수익을 동시에.<br />
              14일 무료 체험 후 결정하셔도 됩니다.</p>
            {/* Billing Toggle */}
            <div className="inline-flex items-center bg-[#F2F4F6] p-1 rounded-full">
              {(["monthly", "annual"] as const).map((b) => (
                <button
                  key={b}
                  onClick={() => setBilling(b)}
                  className={`px-5 py-2 rounded-full text-sm font-bold transition-all cursor-pointer whitespace-nowrap ${
                    billing === b ? "bg-white text-[#191F28]" : "text-[#191F28]/50"
                  }`}
                >
                  {b === "monthly" ? "월간 결제" : "연간 결제"}
                  {b === "annual" && <span className="ml-1.5 text-[#00D873] text-xs">20% 할인</span>}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* ── Pricing Cards ── */}
        <section className="pb-20 px-6 bg-white">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {PLANS.map((plan) => {
                const isPopular = plan.id === "standard";
                const annualPrice = plan.price !== "맞춤"
                  ? Math.floor(parseInt(plan.price.replace(",", "")) * 0.8).toLocaleString()
                  : null;
                const displayPrice = billing === "annual" && annualPrice ? annualPrice : plan.price;

                return (
                  <div
                    key={plan.id}
                    className={`relative rounded-3xl flex flex-col transition-all duration-300 hover:-translate-y-1 ${
                      isPopular
                        ? "bg-white border-2 border-[#00D873]"
                        : "bg-[#F2F4F6] border-2 border-transparent"
                    }`}
                  >
                    {/* Popular Badge */}
                    {plan.badge && (
                      <div
                        className={`absolute -top-3.5 left-1/2 -translate-x-1/2 text-xs font-black px-4 py-1.5 rounded-full whitespace-nowrap ${
                          isPopular ? "bg-[#00D873] text-white" : "bg-[#191F28] text-white"
                        }`}
                      >
                        {plan.badge}
                      </div>
                    )}

                    <div className="p-7 flex flex-col flex-1">
                      {/* Plan Name */}
                      <div className="mb-6">
                        <h3 className="text-lg font-black text-[#191F28] mb-1">{plan.name}</h3>
                        <p className="text-xs text-[#191F28]/50 leading-relaxed">{plan.desc}</p>
                      </div>

                      {/* Price */}
                      <div className="mb-2">
                        <div className="flex items-baseline gap-1">
                          {plan.price !== "맞춤" && <span className="text-base font-bold text-[#191F28]">₩</span>}
                          <span className="text-4xl lg:text-5xl font-black text-[#191F28] leading-none">
                            {displayPrice}
                          </span>
                        </div>
                        <div className="text-xs text-[#191F28]/40 mt-1">
                          {plan.price !== "맞춤" ? plan.unit : "맞춤 견적"}
                          {billing === "annual" && plan.price !== "맞춤" && (
                            <span className="ml-1.5 text-[#00D873] font-bold">연간 20% 할인</span>
                          )}
                        </div>
                      </div>

                      <div className="text-xs text-[#191F28]/40 mb-6 flex items-center gap-1">
                        <i className="ri-group-line" />
                        <span>{plan.limit}</span>
                      </div>

                      {/* Features */}
                      <ul className="space-y-2.5 flex-1 mb-8">
                        {plan.features.map((f) => (
                          <li key={f} className="flex items-start gap-2.5 text-sm">
                            <div className="w-4 h-4 flex items-center justify-center shrink-0 mt-0.5">
                              <i className="ri-check-line text-[#00D873]" />
                            </div>
                            <span className="text-[#191F28]/70 leading-snug">{f}</span>
                          </li>
                        ))}
                      </ul>

                      {/* CTA */}
                      <button
                        onClick={() => setSelectedPlan(plan.name)}
                        className={`w-full py-4 rounded-2xl font-black text-sm transition-all duration-200 cursor-pointer whitespace-nowrap ${plan.btnStyle}`}
                      >
                        {plan.id === "custom" ? "맞춤 견적 문의하기" : "세오 되기 →"}
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* ── Trust Section ── */}
        <section className="py-16 px-6 bg-[#F2F4F6]">
          <div className="max-w-5xl mx-auto text-center">
            <h2 className="text-2xl lg:text-3xl font-black text-[#191F28] mb-10">
              이미 신뢰하고 있어요
            </h2>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
              {[
                { value: "48개", label: "도입 기관 수" },
                { value: "12,400+", label: "누적 수강생" },
                { value: "94%", label: "기관 재도입률" },
                { value: "4.9/5", label: "기관 만족도" },
              ].map((s) => (
                <div key={s.label} className="bg-white rounded-2xl p-6 text-center">
                  <div className="text-3xl font-black text-[#191F28] mb-1">{s.value}</div>
                  <div className="text-xs text-[#191F28]/50">{s.label}</div>
                </div>
              ))}
            </div>

            {/* Feature comparison highlight */}
            <div className="bg-[#191F28] rounded-3xl p-8 lg:p-10 text-white text-left">
              <h3 className="text-xl font-black mb-6 text-center">Standard가 가장 선택받는 이유</h3>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                {[
                  { icon: "ri-robot-line", title: "AI + 전문가 이중 피드백", desc: "AI가 즉각 분석하고, 담당 강사가 최종 인증 마크를 부여합니다." },
                  { icon: "ri-group-line", title: "파티 챌린지 (팀 학습)", desc: "3~4명이 팀을 이루어 하나의 AI 프로젝트를 완성하는 협동 학습." },
                  { icon: "ri-bar-chart-2-line", title: "실시간 학습 리포트", desc: "관리자는 학생별 진도, 점수, 참여율을 실시간으로 확인할 수 있습니다." },
                ].map((f) => (
                  <div key={f.title} className="flex gap-4">
                    <div className="w-10 h-10 flex items-center justify-center bg-[#00D873]/20 rounded-xl shrink-0">
                      <i className={`${f.icon} text-[#00D873] text-xl`} />
                    </div>
                    <div>
                      <div className="font-bold text-sm mb-1">{f.title}</div>
                      <div className="text-white/50 text-xs leading-relaxed">{f.desc}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* ── FAQ ── */}
        <section className="py-16 px-6 bg-white">
          <div className="max-w-2xl mx-auto">
            <h2 className="text-2xl lg:text-3xl font-black text-[#191F28] mb-10 text-center">자주 묻는 질문</h2>
            <div className="space-y-3">
              {FAQS.map((faq, i) => (
                <div key={i} className="bg-[#F2F4F6] rounded-2xl overflow-hidden">
                  <button
                    onClick={() => setOpenFaq(openFaq === i ? null : i)}
                    className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
                  >
                    <span className="font-bold text-[#191F28] text-sm pr-4">{faq.q}</span>
                    <i className={`shrink-0 text-[#191F28]/40 transition-transform ${openFaq === i ? "ri-subtract-line" : "ri-add-line"}`} />
                  </button>
                  {openFaq === i && (
                    <div className="px-6 pb-5 text-sm text-[#191F28]/60 leading-relaxed border-t border-white/50 pt-4">
                      {faq.a}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── Final CTA ── */}
        <section className="py-20 px-6 bg-[#F2F4F6]">
          <div className="max-w-xl mx-auto text-center">
            <h2 className="text-3xl lg:text-4xl font-black text-[#191F28] mb-4">
              14일 무료로<br />직접 경험해 보세요
            </h2>
            <p className="text-[#191F28]/60 mb-8 leading-relaxed">
              신용카드 없이 바로 시작하고, 세오님들의 변화를 직접 확인하세요.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <button
                onClick={() => setSelectedPlan("Standard")}
                className="bg-[#00D873] text-white font-black text-lg px-10 py-4 rounded-full hover:opacity-90 transition-all hover:-translate-y-0.5 cursor-pointer whitespace-nowrap"
              >
                무료 체험 시작하기
              </button>
              <Link
                to="/learning"
                className="flex items-center justify-center gap-2 border-2 border-[#191F28] text-[#191F28] font-bold text-base px-8 py-4 rounded-full hover:bg-[#191F28] hover:text-white transition-all cursor-pointer whitespace-nowrap"
              >
                학습 대시보드 보기
              </Link>
            </div>
          </div>
        </section>

        <FooterSection />
      </div>

      {selectedPlan && (
        <ContactModal plan={selectedPlan} onClose={() => setSelectedPlan(null)} />
      )}
    </div>
  );
}
